import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { filter, Subscription } from 'rxjs';

import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { FilterService } from '../../../../../../Common/Filter/services/abstract-filter.service';
import { CurrentUserStateService } from '../../../../../../Core/Users/services/current-user-state.service';
import { PreferencesModel } from '../../../../../../Core/Users/models/preferences.model';
import { ActivityLogService, CardModel, LoginStatsModel } from './activity-log.service';
import { KeyValue } from '@angular/common';
import { ActivityTypeEnum } from './activity-log.enum';

@Component({
    selector: 'agpr-activity-log',
    templateUrl: './activity-log.component.html',
    styleUrls: ['./activity-log.component.scss'],
    providers: [
        ActivityLogService,
        {
            provide: FilterService,
            useExisting: ActivityLogService
        }
    ],
    animations: [
        trigger('showMoreContent', [
            state('collapsed', style({
                height: '0',
                opacity: 0,
            })),
            state('expanded', style({
                height: '*',
                opacity: 1,
            })),
            transition('expanded <=> collapsed', animate('400ms 100ms cubic-bezier(.43,.43,.65,.99)')),
        ]),
    ],
    standalone: false
})
export class ActivityComponent implements OnInit, OnDestroy {

    readonly messageSeverity = messageSeverityEnum;
    readonly activityTypeEnum = ActivityTypeEnum;
    preferences: PreferencesModel;
    subscriptions: Subscription[] = [];

    @Input() set userId(value: number) {
        if(value) {
            this.activityLogService.getActivities(value);
        }
    }

    activities: CardModel[] = [];
    filteredActivities: CardModel[] = [];
    loginStats: LoginStatsModel = { recentLoginCount: 0 };

    constructor(
        public currentUserStateService: CurrentUserStateService,
        public activityLogService: ActivityLogService
    ) {}

    ngOnInit(): void {
        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(pref => !!pref)).subscribe(
                prefs => this.preferences = prefs
            ),
            this.activityLogService.activities$.subscribe(
                activities => this.activities = activities
            ),
            this.activityLogService.filteredActivities$.subscribe(
                filteredActivities => this.filteredActivities = filteredActivities
            ),
            this.activityLogService.loginStats$.subscribe(
                loginStats => this.loginStats = loginStats
            )
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    compareFn(a: KeyValue<string, string>, b: KeyValue<string, string>): number {
        const order = ['reason', 'method', 'userIP'];
        return order.indexOf(a.key) - order.indexOf(b.key);
    };
}
